<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>CALIFICACIÓN</h1>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-3">
        <nav class="navbar navbar-expand navbar-light">
            <div id="navLicitaciones" class="collapse navbar-collapse d-flex flex-row-reverse">
                <ul class="navbar-nav row">
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/familias']" class="nav-link m-1 pl-3 pr-3">Familias</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/calificacion']" class="nav-link m-1 pl-3 pr-3 disabled" tabindex="-1" aria-disabled="true">Calificación</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/ofertas-de-licitacion']" class="nav-link m-1 pl-3 pr-3 "> Ofertas de Licitación</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/postulantes-ofertas']" class="nav-link m-1 pl-3 pr-3" tabindex="-1" aria-disabled="true"> Postulantes por oferta</a>
                    </li>
                    <!-- <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/consultas-reportes']" class="nav-link m-1 pl-3 pr-3 "> Consultas/Reportes </a>
                    </li> -->
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/login']" class="nav-link cerrar m-1 pl-3 pr-3 redBtn">Cerrar sesión</a>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="row pb-5 mt-5">
            <div class="col-12 mb-1">
                <div class="row FlstLi mb-2">
                    <div class="col-6 col-md-6 col-lg-3 text-left my-2 ">
                        <button type="submit" class="mr-2" (click)="addCalificacion()"> Agregar Nueva Calificacion</button>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center mx-auto">
                <div class="FlstLi table-responsive">
                    <table class="Ftabla Ftablon table dDoce">
                        <tr>
                            <th scope="col" class="pl-2 pr-2">Calificación</th>
                            <th scope="col" class="pl-2 pr-2">Activo</th>
                        </tr>
                        <tr></tr>
                        <tbody class="tablaBlq" *ngFor="let calificacion of calificaciones | paginate: { itemsPerPage: 5, currentPage: p }">
                            <tr>
                                <td class="pl-2 pr-2 align-middle" (click)="change(calificacion)">{{calificacion.calificacion}}</td>
                                <td class="pl-2 pr-2 align-middle" (click)="change(calificacion)">{{calificacion.activo ? 'Si' : 'No'}}</td>
                            </tr>
                            <tr></tr>
                        </tbody>
                    </table>
                    <pagination-controls previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="p = $event"></pagination-controls>
                </div>
            </div>
        </div>
        <div class="col-12 alerta-confirmar blqCtr text-center" *ngIf="this.editar">
            <div class="row mb-2">
                <h4>Actualiza Calificacion</h4>
            </div>
            <form  ngNativeValidate #Update="ngForm" (ngSubmit)="UpdateCalifo(Update)"  class="pb-3 row">
                <div class="row">
                    <div class="form-group col-6 text-left">
                        <input [(ngModel)]="estatusUpdate" name="estatusUpdate" type="checkbox" id="estatusUpdate" class="form-check-input" checked>
                        <label for="estatusUpdate" class="form-check-label">&nbsp;Activa</label>
                    </div>
                    <div class="form-group col-12 text-left">
                        <label for="calificacionUpdate">Calificacion</label>
                        <input [(ngModel)]="calificacionUpdate" name="calificacionUpdate" type="text" id="calificacionUpdate" maxlength="50" required class="form-control">
                    </div>
                    <div class="col-12">
                        <button type="submit" class="mr-2"> Actualizar </button>
                        <button class="ml-2 redBtn" (click)="cancel()"> Cancelar</button>
                    </div>
                </div>
            </form>
        </div>

        <div class="col-12 alerta-confirmar blqCtr text-center" *ngIf="this.addd">
            <div class="row mb-2">
                <h4>Alta Nueva Califiacion</h4>
            </div>
            <form  #f="ngForm" (ngSubmit)="confirmacionAgregar(f)" ngNativeValidate class="pb-3 row">
                <div class="row">
                    <div class="form-group col-12 text-left">
                        <label for="calificacion">Calificacion</label>
                        <input ngModel name="calificacion" type="text" id="calificacion" maxlength="50" required class="form-control">
                    </div>
                    <div class="col-12">
                        <button type="submit" class="mr-2"> Guardar y Salir</button>
                        <button class="ml-2 redBtn" (click)="cancel()"> Cancelar</button>
                    </div>
                </div>
            </form>
        </div>

        <div class="col-12 alerta-exito blqCtr text-center" *ngIf="this.success">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-warning.png">
            <p>¿La información que ingreso es correcta?</p>
            <button class="btn-confirmar mr-2" (click)="closeok()">Aceptar</button>
            <button class="ml-2 redBtn" (click)="closefail()"> Cancelar</button>
        </div>

	</div>

</div>